<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M4.80002 3.6c-.63652 0-1.24696.25285-1.69705.70294C2.65288 4.75303 2.40002 5.36348 2.40002 6v12c0 .6365.25286 1.247.70295 1.6971.45009.45 1.06053.7029 1.69705.7029H19.2c.6365 0 1.247-.2529 1.6971-.7029.4501-.4501.7029-1.0606.7029-1.6971V6c0-.63652-.2528-1.24697-.7029-1.69706C20.447 3.85285 19.8365 3.6 19.2 3.6H4.80002Zm3.6 2.4H15.6v4.8H8.40002V6ZM18 15.6V18h1.2v-2.4H18Zm-2.4-2.4H8.40002V18H15.6v-4.8Zm2.4 0h1.2v-2.4H18v2.4Zm1.2-4.8V6H18v2.4h1.2ZM6.00002 6v2.4h-1.2V6h1.2Zm0 4.8h-1.2v2.4h1.2v-2.4Zm-1.2 4.8h1.2V18h-1.2v-2.4Z"
            clip-rule="evenodd"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M21.41 3.59C21.03 3.21 20.53 3 20 3H4c-.53 0-1.04.21-1.41.59C2.21 3.97 2 4.47 2 5v14c0 .53.21 1.04.59 1.41.38.37.88.59 1.41.59h16c.53 0 1.04-.21 1.41-.59.37-.38.59-.88.59-1.41V5c0-.53-.21-1.04-.59-1.41ZM6 19H4v-2h2v2Zm0-4H4v-2h2v2Zm0-4H4V9h2v2Zm0-4H4V5h2v2Zm10 12H8v-6h8v6Zm0-8H8V5h8v6Zm4 8h-2v-2h2v2Zm0-4h-2v-2h2v2Zm0-4h-2V9h2v2Zm0-4h-2V5h2v2Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
